<template>
  <div>
    <div class="login-wrap">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h3 class="title">展商登录</h3>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="密码"
          ></el-input>
        </el-form-item>
<!--        <el-form-item prop="mobile" v-if="login_way==2">-->
<!--          <el-input-->
<!--              type="text"-->
<!--              v-model="ruleForm.mobile"-->
<!--              auto-complete="off"-->
<!--              placeholder="手机号"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->
        <el-form-item prop="smsCode" v-if="login_way==2">
          <el-input type="text" v-model="ruleForm.smsCode" auto-complete="off"
                    placeholder="请输入验证码">
              <span slot="suffix">
           <span
               style="font-weight: 400;font-size: 14px;color: #1677FF;line-height: 40px; cursor: pointer;"
               v-if="countdown==60"
               @click="getFlag(ruleForm)">获取验证码</span>
              <span v-else style="font-weight: 400;font-size: 14px;line-height: 40px;">已发送（{{ countdown }}s）</span>
              </span>

          </el-input>
        </el-form-item>

        <div class="bottom_box">
          <el-checkbox class="remember" v-model="rememberpwd"
            >记住密码</el-checkbox
          >
          <!--<span class="wjpass" @click="open">忘记密码</span>-->
        </div>
        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span class="dialog_box">忘记密码请联系：010-68512208</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" size="medium"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {login, getLocationTree, getmyMenu, menuSwitch, SafeLogin_send_pcode, SafeLogin_login_way} from "@/api/api";
import { setCookie, getCookie, delCookie } from "../utils/util";
export default {
  name: "login",
  data() {
    return {
      dialogVisible: false,
      //定义loading默认为false
      countdown:60,
      login_way:0,
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: "",
        // mobile: "",
        password: "",
        // code: "",
        randomStr: "",
        codeimg: "",
        smsCode: "",
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        // mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd();
    this.get_SafeLogin_login_way();
  },
  // 里面的函数只有调用才会执行
  methods: {
    open() {
      this.dialogVisible = true;
    },

    // 获取用户名密码
    getuserpwd() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.ruleForm.username = getCookie("user");
        this.ruleForm.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },

    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          //this.$store.dispatch("userLogin", false);
          localStorage.removeItem("Flag");
          var reqParam = {
            // mobile: this.ruleForm.username||'',
            smsCode: this.ruleForm.smsCode||'',
            account: this.ruleForm.username,
            password: this.ruleForm.password,
            // verify_code: this.ruleForm.code,
            terminal: 1,
          };
          login(reqParam)
            .then((res) => {
              if (res.data.code == 1) {
                let loginRes = {
                  token: res.data.data.token,
                  isLogin: true,
                };
                this.$store.commit("userStatus", loginRes);
                localStorage.setItem("Flag", "isLogin");
                if (this.rememberpwd) {
                  //保存帐号到cookie，有效期7天
                  setCookie("user", this.ruleForm.username, 7);
                  //保存密码到cookie，有效期7天
                  setCookie("pwd", this.ruleForm.password, 7);
                } else {
                  delCookie("user");
                  delCookie("pwd");
                }
                // this.getconfigdict()
                this.getmenuSwitch();
                this.getLocationTree();
                this.getmyMenu();
                // 缓存token 用户个人信息
                localStorage.setItem("userdata", JSON.stringify(res.data.data));
              } else {
                console.log(res.data, "res.data");
                this.$message.warning(res.data.msg);
                this.logining = false;

                return false;
              }
            })
            .catch((err) => {
              this.logining = false;
            });
        } else {
          this.$message.error("请输入用户名密码！");
          this.logining = false;
          return false;
        }
      });
    },
    getmenuSwitch() {
      menuSwitch()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;

            //如果请求成功就让他2秒跳转路由
            setTimeout(() => {
              this.logining = false;
              if (data.menu_switch == "NHNE") {
                this.$router.push({
                  path: "/discussionindex",
                });
              } else {
                this.$router.push({
                  path: "/index",
                });
              }
            }, 1000);
            this.$store.commit("menu_switch", data.menu_switch);
            sessionStorage.setItem("menu_switch", data.menu_switch);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取左侧菜单
    getmyMenu() {
      getmyMenu()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.$store.commit("menuStatus", JSON.stringify(data));
            localStorage.setItem("menu", JSON.stringify(data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取登录方式
    get_SafeLogin_login_way() {
      SafeLogin_login_way()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.login_way=data.login_way
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取国家
    getLocationTree() {
      getLocationTree({})
        .then((res) => {
          if (res.data.code == 1) {
            localStorage.setItem("locationdata", JSON.stringify(res.data.data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFlag(form) {
      if (form.username.length > 0) {
        let data = {
          account: this.ruleForm.username,
        }
        SafeLogin_send_pcode(data).then(res => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg)
              this.timer()
          } else {
          }
        })
        // }
      } else {
        this.$message.error('请填写账号');
      }
    },
    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 60
        return
      }
      setTimeout(() => {
        this.countdown=this.countdown - 1
        this.timer();
      }, 1000);
    },

  },
};
</script>

<style lang="scss" scoped>
/*/deep/ .el-dialog__wrapper{*/
/*z-index: 2005 !important;*/
/*}*/
/deep/ .el-dialog {
  margin-top: 30vh !important;
}
/deep/ .el-button--primary,
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, 
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fc933f;
  border-color: #fc933f;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #fc933f;
}
.dialog_box {
  font-size: 16px;
  font-weight: bold;
}
.login-wrap {
  width: 100%;
  height: 100%;
  position: fixed;

  background-image: url("../assets/loginbg.jpg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 59%;
  transform: translateY(-50%);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.bottom_box {
  display: flex;
  justify-content: space-between;
}
.wjpass {
  color: #666;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #666;
}
@media only screen and (max-width: 767px) {
  .login-wrap {
    display: flex;
    align-items: center;
    background-size: 100%;
  }
  .login-container {
    width: 70%;
  }
}
</style>